import { Checkbox, FormControlLabel, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const [checked, setChecked] = useState(false);

	const onChange = (event: object, value: boolean) => {
		setChecked(value);
	};

	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="Label with tooltip" />
			<Checkbox
				checked={checked}
				labelProps={{
					label: "Long Label With Tooltip",
					sx: { maxWidth: "100px" },
					wrap: false,
				}}
				onChange={onChange}
			/>
		</CssColumnGrid>
	);
};